<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  fill="none"
  viewBox="0 0 18 14"
>
  <path
    [attr.fill]="color"
    d="M2 7L1.46967 7.53033L0.939341 7L1.46967 6.46967L2 7ZM18 7.75H2V6.25H18V7.75ZM8.53033 1.53033L2.53033 7.53033L1.46967 6.46967L7.46967 0.46967L8.53033 1.53033ZM2.53033 6.46967L8.53033 12.4697L7.46967 13.5303L1.46967 7.53033L2.53033 6.46967Z"
  />
</svg>
